import { Box } from "@mui/material";
import ModuleTabs from "./ModuleTabs";
import PageHeader from "./PageHeader";

const ModuleLayout = ({ title, subtitle, breadcrumbs, tabs, dataMode, actions, children, compactHeader = false }) => (
  <Box className="module-layout" sx={{ pt: 3, minHeight: "100%", minWidth: 0 }}>
    <PageHeader title={title} subtitle={subtitle} breadcrumbs={breadcrumbs} dataMode={dataMode} actions={actions} compact={compactHeader} />
    {tabs?.length > 0 && <ModuleTabs tabs={tabs} />}
    <Box className="module-content" sx={{ minWidth: 0 }}>{children}</Box>
  </Box>
);

export default ModuleLayout;
